<template>
  <button
    aria-label="Clear search"
    @click="handleClear"
    :class="[
      'text-aubergine focus:outline-none rounded-full bg-transparent',
      props.classes,
    ]"
  >
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Reset">
        <rect
          id="Rectangle 1654"
          opacity="0.2"
          width="18"
          height="18"
          rx="9"
          fill="currentColor"
        />
        <g id="Group 2786">
          <path
            id="Vector 4"
            d="M6 12L12.0007 5.99934"
            stroke="currentColor"
            stroke-width="2"
          />
          <path
            id="Vector 5"
            d="M6 6L12.0007 12.0007"
            stroke="currentColor"
            stroke-width="2"
          />
        </g>
      </g>
      <g id="Search/Default"></g>
    </svg>
  </button>
</template>
<script lang="ts" setup>
const props = defineProps<{ classes?: string }>();
type Emits = {
  (e: "handleClear"): void;
};

const handleClear = () => {
  emit("handleClear");
};

const emit = defineEmits<Emits>();
</script>
```
